import { useEffect, useRef } from "react";

const problems = [
  {
    num: "01",
    title: "Повільна комунікація",
    description:
      "Кандидати губляться ще до першого контакту. Job-портали, форми, месенджери, дзвінки, рекомендації, різні міста й локації. Частина кандидатів без резюме — тільки ім'я, телефон і бажана точка роботи.",
  },
  {
    num: "02",
    title: "50% часу йде на рутину",
    description:
      "Потрібно знайти відгук, перевірити локацію, уточнити базові дані, зателефонувати, поставити статус, нагадати менеджеру й не забути про повторний контакт.",
  },
  {
    num: "03",
    title: "Не видно, де втрачаються люди і бюджет",
    description:
      "Відгуки є, вакансії відкриті, рекрутери працюють. Але незрозуміло, що саме просідає: джерело, місто, локація, етап, швидкість відповіді, погодження з менеджером чи умови вакансії.",
  },
];

export default function ProblemSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = entry.target.querySelectorAll(".problem-animate");
            children.forEach((child, i) => {
              setTimeout(() => child.classList.add("visible"), i * 150);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="problems"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-[#f5f5f7]"
    >
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="problem-animate animate-on-scroll text-[32px] sm:text-[40px] lg:text-[48px] font-semibold leading-[1.15] tracking-tight text-[#1d1d1f] mb-5">
            <span className="gradient-text-blue-purple">Дефіцит кадрів — це лише частина проблеми</span>
          </h2>
          <p className="problem-animate animate-on-scroll text-[18px] sm:text-[19px] lg:text-[20px] text-[#6e6e73] leading-relaxed max-w-[700px] mx-auto">
            Навіть коли кандидат уже відгукнувся, його ще легко втратити: між каналами, дзвінками, ручною звіркою статусів та етапів, які ніхто не бачить у цифрах.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="problem-animate animate-on-scroll bg-white rounded-[24px] p-7 md:p-8 relative overflow-hidden transition-transform duration-300 hover:scale-[1.02] cursor-default min-h-[320px] md:min-h-[380px] border border-[#e5e5ea]"
            >
              <span className="absolute top-6 right-6 text-[80px] md:text-[96px] font-bold leading-none text-[#1d1d1f]/5 select-none">
                {problem.num}
              </span>
              <div className="relative z-10 flex flex-col h-full pt-24 md:pt-28">
                <h3 className="text-[22px] md:text-[26px] font-semibold gradient-text-blue-purple leading-tight mb-2 md:mb-3">
                  {problem.title}
                </h3>
                <p className="text-[18px] sm:text-[19px] lg:text-[20px] text-[#6e6e73] font-medium leading-normal">
                  {problem.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}